import Vue from 'vue'
import Vuex from 'vuex'
import api from "@/api";

Vue.use(Vuex)
import CONSTANTS from "@/store/constants";

/* eslint-disable */
const state = {
    decisionBranches: {
        sections: [],
        cards: []
    },
    currentUser: {},
    authToken: null,
    authResponse: {},
    isLoading: false,
    showSearchSpinner: false,
    errorMessage: undefined,
    currentAlias: null,
    currentAppData: null,
    searchKeyword: null,
    currentSubCategory: null,
    successMessage: undefined,
    breadcrumbItems: [],
    allCategories: [],
    historyArray: [],
    currentCategory: null,
    searchResult: null,
    isComponentRequest: false,
}

/* eslint-disable no-shadow */
const getters = {
    decisionBranches(state) {
        return state.decisionBranches;
    },
    currentAlias(state) {
        return state.currentAlias;
    },
    allCategories(state) {
        return state.allCategories;
    },
    breadcrumbItems(state) {
        return state.breadcrumbItems;
    },
    searchKeyword(state) {
        return state.searchKeyword;
    },
    currentAppData(state) {
        return state.currentAppData;
    },
    currentSubCategory(state) {
        return state.currentSubCategory;
    },
    isLoading(state) {
        return state.isLoading;
    },
    showSearchSpinner(state) {
        return state.showSearchSpinner;
    },
    isComponentRequest(state) {
        return state.isComponentRequest;
    },

    errorMessage(state) {
        return state.errorMessage;
    },
    currentUser(state) {
        if (!state.authResponse) return undefined;
        return state.authResponse.user;
    },
    authResponse(state) {
        return state.authResponse;
    },
    authToken(state) {
        return state.authToken
    },
    successMessage(state) {
        return state.successMessage;
    },
    historyArray(state) {
        return state.historyArray;
    },
    currentCategory(state) {
        return state.currentCategory
    },
    searchResult(state) {
        return state.searchResult;
    }
}

const mutations = {
    setDecisionBranches(state, decisionBranches) {
        state.decisionBranches = decisionBranches;
    },
    setAllCategories(state, allCategories) {
        state.allCategories = allCategories
    },
    setBreadcrumbItems(state, breadcrumbItems) {
        state.breadcrumbItems = breadcrumbItems
    },
    setCurrentAlias(state, currentAlias) {
        state.currentAlias = currentAlias
    },
    setSearchKeyword(state, searchKeyword) {
        state.searchKeyword = searchKeyword
    },
    setCurrentAppData(state, currentAppData) {
        state.currentAppData = currentAppData
    },
    setCurrentSubCategory(state, currentSubCategory) {
        state.currentSubCategory = currentSubCategory
    },
    setAuthResponse(state, authResponse) {
        state.authResponse = authResponse
    },
    setAuthToken(state, authToken) {
        state.authToken = authToken
    },
    setIsLoading(state, isLoading) {
        state.isLoading = isLoading;
    },
    setShowSearchSpinner(state, showSearchSpinner) {
        state.showSearchSpinner = showSearchSpinner;
    },
    setIsComponentRequest(state, isComponentRequest) {
        state.isComponentRequest = isComponentRequest;
    },

    setErrorMessage(state, errorMessage) {
        state.errorMessage = errorMessage;
    },
    setSuccessMessage(state, successMessage) {
        state.successMessage = successMessage;
        setTimeout(() => {
            state.successMessage = null;
        }, 5000);
    },
    setHistoryArray(state, historyArray) {
        state.historyArray = historyArray;
    },
    setCurrentCategory(state, currentCategory) {
        state.currentCategory = currentCategory;
    },
    setSearchResult(state, searchResult) {
        state.searchResult = searchResult;
    }
}
const actions = {
    async fetchDecisionBranches({commit, getters}) {
        let decisionBranches = {
            sections: [],
            cards: []
        };
        let currentAppData = getters.currentAppData;

        if(currentAppData.quickLinks && currentAppData.quickLinks.length > 0) {
            let section = {}
            section.id = "quickLinksId"
            section.ehOrder = 0
            section.name = "Quick links"
            section.displayType = "Carousel"
            section.jumpLink = "quickLinksId"
            decisionBranches.sections.push(section)

            currentAppData.quickLinks.forEach(quickLink => {
                let card = {}
                card.id = quickLink.id
                card.name = quickLink.name
                card.section = "quickLinksId"
                card.description = quickLink.name
                card.image = quickLink.image
                card.ehOrder = quickLink.ehOrder
                card.actionType = "LINK"
                card.actionLink = quickLink.link
                decisionBranches.cards.push(card)
            })
        }

        if(currentAppData.categories && currentAppData.categories.length > 0) {
            currentAppData.categories.forEach(category => {
                let childCategories = category.childCategories
                let section = {}
                section.id = category.id
                section.ehOrder = category.ehOrder
                section.name = category.name
                section.displayType = "Standard"
                section.jumpLink = category.id
                section.description = category.description

                if(currentAppData.supportList && currentAppData.supportList.length > 0) {
                    currentAppData.supportList.forEach(supportData => {
                        if(supportData.title) {
                            var supportTitle = supportData.title.replaceAll(" ", "").toLowerCase()
                            if (supportTitle.includes(CONSTANTS.SUPPORT_TITLE_CHECK_TEXT)) {
                                section.support = {name: supportData.title, url: supportData.value}
                            }
                        }
                    })
                }

                if (category.helpfulLinks && category.helpfulLinks.length > 0) {
                    section.subSection1Name = "Helpful links"
                    section.subSection1Resources = []
                    category.helpfulLinks.forEach(helpfulLink => {
                        section.subSection1Resources.push(helpfulLink);
                    })
                }

                if (category.policies && category.policies.length > 0) {
                    section.subSection2Name = "Policies"
                    section.subSection2Resources = []
                    category.policies.forEach(policy => {
                        section.subSection2Resources.push(policy);
                    })
                }

                if (category.support && category.support.length > 0) {
                    section.subSection3Name = "Support"
                    section.subSection3Resources = []
                    category.support.forEach(support => {
                        section.subSection3Resources.push(support);
                    })
                }

                decisionBranches.sections.push(section)

                if (childCategories && childCategories.length > 0) {
                    childCategories.forEach(child => {
                        let card = {}
                        card.id = child.id
                        card.name = child.name
                        card.section = child.parentCategoryId
                        card.description = child.description

                        if (child.solutions && child.solutions.length > 0) {
                            if (child.solutions[0].targets && child.solutions[0].targets.length > 0) {
                                if (child.solutions[0].targets.length > 1) {
                                    card.actionType = "MODAL"
                                    card.solutions = []
                                    child.solutions[0].targets.forEach(target => {
                                        let solution = {}
                                        solution.id = target.id
                                        solution.description = target.linkName
                                        solution.name = target.linkName
                                        solution.url = target.linkValue
                                        card.solutions.push(solution)
                                    })
                                } else {
                                    card.actionType = "LINK"
                                    card.actionLink = child.solutions[0].targets[0].linkValue
                                }
                            }
                        }

                        decisionBranches.cards.push(card)
                    })

                }
            })
        }

        commit(
            "setDecisionBranches",
            decisionBranches
        );

    },
    getAppData({commit, state}, alias) {
        commit("setIsLoading", true);
        return api.getAppdata(alias).then((response) => {
            if (response.data.errors) {
                if (response.data.errors[0].message.indexOf("Access denied") !== -1) {
                    let errorPage = "/forbidden";
                    if (process.env.VUE_APP_ENVIRONMENT === 'LOCAL')
                        errorPage = process.env.VUE_APP_EH_URL + "/forbidden";
                    location.href = errorPage;
                } else {
                    commit("setErrorMessage", CONSTANTS.ERROR_MESSAGE);
                }
            } else {
                var guidedPlatformAppData = response.data.data.getGuidedPlatformAppData;
                commit("setCurrentAppData", guidedPlatformAppData);
            }

        }).finally(() => {
            commit("setIsLoading", false);
        });
    }
}
const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions
})

export default store
